import { render, staticRenderFns } from "./form-text.vue?vue&type=template&id=c963ff5e&scoped=true&"
import script from "./form-text.vue?vue&type=script&lang=js&"
export * from "./form-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963ff5e",
  null
  
)

export default component.exports